import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { apiService } from 'src/app/service/api.service';
import { StorageService } from 'src/app/service/storage.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-cambiar-fotoperfil',
  templateUrl: './modal-cambiar-fotoperfil.component.html',
  styleUrls: ['./modal-cambiar-fotoperfil.component.css']
})
export class ModalCambiarFotoperfilComponent implements OnInit {

  dataArchivo = new FormData();
  archivoCargado = false;
  incorrecta = false;
  cargando = true;
  @ViewChild('inputFile') inputArchivo: ElementRef;
  @ViewChild('divSpinnerModal') divSpinnerModal:ElementRef;
  url = '';

  constructor(
    private api: apiService,    
    public storageService: StorageService,   
    public dialogRef: MatDialogRef<ModalCambiarFotoperfilComponent>,
  ) { }

  ngOnInit(): void {
    this.cargando=false;
  }

  cambioArchivo(event){ 
    this.dataArchivo = new FormData();
    const extension = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf(".") + 1, event.target.files[0].name.length)
    const extensionesValidas = ["jpg","jpeg","png"];
    const existeExtension = extensionesValidas.map(x=>x).indexOf(extension.toLowerCase());
    this.url = "";
    if(existeExtension == -1){
      Swal.fire({
        title: 'Error!',
        text: 'Ingrese un archivo válido',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }else{
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.url = event.target.result as string;
      }

      this.dataArchivo.append('nombre', event.target.files[0].name)
      this.dataArchivo.append('file', event.target.files[0])
      this.dataArchivo.append('idUsuario', this.storageService.getCurrentUser().idUsuario.toString())
      this.archivoCargado = false;
    }
  }

  subirArchivo(event){
    this.divSpinnerModal.nativeElement.style.display='';
      this.inputArchivo.nativeElement.value = null;
        this.api.API_POST_actualizarFotoPerfil(this.dataArchivo).subscribe((response) => {
          this.divSpinnerModal.nativeElement.style.display='none';
          this.dialogRef.close();
        },
        (err) => {
          console.log(err);
          this.divSpinnerModal.nativeElement.style.display='none';
          Swal.fire({
            title: 'Error!',
            text: 'Error al subir la foto de perfil',
            icon: 'error',
            confirmButtonText: 'OK'
          })
      })

    
  }

  onNoClick(){
    this.dialogRef.close();
  }
  
}
